/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */

/**
 * Severity level of the rule
 */
export type IncidentRuleSeverity = (typeof IncidentRuleSeverity)[keyof typeof IncidentRuleSeverity];

export const IncidentRuleSeverity = {
  MINOR: 'minor',
  MAJOR: 'major',
  CRITICAL: 'critical',
} as const;
